import React, { useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { CircularProgress, Box } from '@mui/material';

// Component to protect routes that require authentication
const ProtectedRoute: React.FC = () => {
  const { isAuthenticated, isLoading, refreshUserData, user } = useAuth();
  const [isRefreshing, setIsRefreshing] = useState(false);
  
  // Refresh user data on mount only, not on every render
  useEffect(() => {
    const refreshData = async () => {
      if (isAuthenticated && !isLoading) {
        setIsRefreshing(true);
        await refreshUserData();
        setIsRefreshing(false);
      }
    };
    
    refreshData();
  }, [isAuthenticated, isLoading, refreshUserData]);
  
  // Show loading indicator if auth state is still being determined or refreshing
  if (isLoading || isRefreshing) {
    return (
      <Box 
        sx={{ 
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center', 
          height: '100vh' 
        }}
      >
        <CircularProgress />
      </Box>
    );
  }
  
  // Redirect to home if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }
  
  // Render the child routes if authenticated
  return <Outlet />;
};

export default ProtectedRoute; 